import React, { useState, useEffect } from 'react';
import './Project.css'; // 记得在 CSS 中为 lightbox 写样式

export default function ProjectContent({ projects, activeId, lang }) {
  const [lightboxContent, setLightboxContent] = useState(null);

  // 监听 Esc 键关闭
useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setLightboxContent(null);
    }
  };

  window.addEventListener('keydown', handleKeyDown);

  // 清理事件监听
  return () => window.removeEventListener('keydown', handleKeyDown);
}, []);


  const project = projects.find(p => p.id === activeId);
  if (!project) return null;

  const openLightbox = (type, src) => {
    setLightboxContent({ type, src });
  };

  const closeLightbox = () => {
    setLightboxContent(null);
  };


  return (
    <div className="project-content">
      <h2>{project.title[lang]}</h2>
      <p>{project.description[lang]}</p>

      {project.sections.map((section, idx) => (
        <div key={idx} className="project-section">
          <h3>{section.heading[lang]}</h3>
          <p>{section.content[lang]}</p>
        </div>
      ))}

      {project.images && project.images.length > 0 && (
        <div className="project-images">
          {project.images
            .filter(img => !img.lang || img.lang === lang)
            .map((img, idx) => (
              <figure key={idx}>
                <img
                  className="clickable"
                  src={img.src}
                  alt={img.caption[lang]}
                  onClick={() => openLightbox('image', img.src)}
                  style={{ cursor: 'pointer' }}
                />
                <figcaption>{img.caption[lang]}</figcaption>
              </figure>
            ))}
        </div>
      )}

      {project.videos && project.videos.length > 0 && (
        <div className="project-videos">
          {project.videos.map((video, idx) => (
            <figure key={idx}>
              <video
                className="clickable"
                src={video.src}
                controls
                width="100%"
                onClick={() => openLightbox('video', video.src)}
                style={{ cursor: 'pointer' }}
              />
              <figcaption>{video.caption[lang]}</figcaption>
            </figure>
          ))}
        </div>
      )}

      {/* Lightbox */}
      {lightboxContent && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            {lightboxContent.type === 'image' && (
              <img src={lightboxContent.src} alt="Enlarged" />
            )}
            {lightboxContent.type === 'video' && (
              <video src={lightboxContent.src} controls autoPlay />
            )}
            <button className="lightbox-close" onClick={closeLightbox}>✕</button>
          </div>
        </div>
      )}
    </div>
  );
}

